import _ from 'lodash';
import template from './genericPanel.html';


export default {
  name: 'genericPanel',
  replace: true,
  template,
  bindToController: true,
  controller: GenericPanelController,
  bindings: {
    panelId: '<'
  }
};

/* @ngInject */
function GenericPanelController($scope, growl, GenericPanelService, DashboardService) {
  const vm = this;

  // public variables
  vm.loadingSpinners = {};
  vm.editPanel = {
    needsToBeConfigured: false
  };
  vm.panel = null;
  vm.headerModel = {};
  vm.activeEquipmentId = null;

  // public functions
  vm.$onInit = init;
  vm.$onDestroy = destroy;
  vm.getStatusForEquipment = getStatusForEquipment;
  vm.isOfType = isOfType;
  vm.setActiveEquipment = setActiveEquipment;
  vm.updateValuesFromEvent = updateValuesFromEvent;
  vm.saveNewValues = saveNewValues;
  vm.setStatuses = setStatuses;
  vm.sortProperties = sortProperties;
  vm.sortEditable = sortEditable;
  vm.destroy = destroy;
  vm.getPrettyName = getPrettyName;
  vm.cancelEdit = cancelEdit;
  vm.editChange = editChange;

  vm.tempEquipments = {};
  vm.equipmentArrays = {};
  vm.sortPropertiesDirection = 0;
  vm.sortValuesDirection = 0;
  vm.sortingEditable = true;
  vm.isDirty = false;

  /**
   * Set the new values to the statuses.  Creates them if they don't exist.
   * Filters updates by statusesToShow array or excludeFromPanel array
   * TODO: This function is full of WAT -Bin
   *
   * @param {object} panel
   * @param {object} panel.config
   * @param {string} equipment ID
   * @param {object} data Contains a key and a value for each piece of data to display. Value can be object or number
   * @returns {undefined}
   */
  function setStatuses(panel, equipment, data) {
    let specificStatuses = null;
    if (
      _.has(panel, ['config', equipment, 'statusesToShow']) &&
            _.isArray(panel.config[equipment].statusesToShow) &&
            _.size(panel.config[equipment].statusesToShow)
    ) {
      // Explicitly Including: only show specific points, nothing else
      specificStatuses = panel.config[equipment].statusesToShow;
    } else if (
      _.has(panel, ['config', equipment, 'excludeFromPanel']) &&
            _.isArray(panel.config[equipment].excludeFromPanel) &&
            _.size(panel.config[equipment].excludeFromPanel)
    ) {
      // Explicitly Excluding: exclude specific points, but show everything else
      specificStatuses = _.difference(_.keys(data), panel.config[equipment].excludeFromPanel);
    }
    const keys = specificStatuses || _.keys(data);

    _.forEach(keys, (key) => {
      if (_.has(data, key)) {
        const status = _.isPlainObject(data[key]) ? data[key] : {
          value: data[key],
          updatedAt: false
        };
        vm.equipments[equipment].statuses[key] = status;
      }
    });
    vm.equipmentArrays[equipment] = _.entries(vm.equipments[equipment].statuses);
  }

  function init() {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];
    if (vm.panel && vm.panel.equipment && vm.panel.equipment.length) {
      // panel is good to go
      vm.loadingSpinners.stopGenericPanel = false;
      vm.editPanel.needsToBeConfigured = false;

      GenericPanelService.getEquipmentFromIdsPerPanel(vm.panel.id, vm.panel.equipment)
        .then((equipment) => {
          if (_.size(equipment)) {
            vm.equipments = equipment;
            setActiveEquipment(_.values(equipment)[0].equipment);
            _.forEach(equipment, ({ equipment: eq }) => {
              getStatusForEquipment(eq.id);
              vm.headerModel[eq.id] = eq;
            });
          } else {
            vm.editPanel.needsToBeConfigured = true;
          }
        });
      setupEventListeners(vm.panel.equipment);
    } else {
      // panel needs to be configured
      vm.loadingSpinners.stopGenericPanel = true;
      vm.editPanel.needsToBeConfigured = true;
    }
  }

  function setupEventListeners(equipments) {
    _.forEach(equipments, (equipmentId) => {
      $scope.$on(`event:${equipmentId}`, (__, { equipment, data, eventName }) => {
        // if 'listenForEvent' for this equipment is specified, process event if 'eventName'
        // matches the 'listenForEvent'
        // if 'listenForEvent' is NOT specified for this equipment, process all events for
        // this equipment
        const processEvent =
            _.isEmpty(_.get(vm.panel, ['config', equipment.id, 'listenForEvent'], null)) ||
            vm.panel.config[equipment.id].listenForEvent === eventName;

        if (processEvent) {
          vm.updateValuesFromEvent(equipment.id, data);
        }
      });
    });
  }

  /**
   * @param {string} equipment ID
   * @param {boolean} refresh skip cache
   * @returns {Promise<object>} Status
   */
  function getStatusForEquipment(equipment, refresh = false) {
    const equips = vm.equipments;
    return GenericPanelService.getStatusForEquipment(equipment, refresh)
      .then((data) => {
        vm.activeEquipmentId = vm.activeEquipmentId || equipment;
        equips[equipment].statuses = {};

        setStatuses(vm.panel, equipment, data);

        equips[equipment].foundEdit = false;
        _.forEach(equips[equipment].statuses, (status) => {
          if (status.configurable) {
            equips[equipment].foundEdit = true;
          }
        });
        vm.loadingSpinners.stopGenericPanel = true;
        equips[equipment].errorLoading = false;
      })
      .catch(() => {
        equips[equipment].errorLoading = true;
        vm.loadingSpinners.stopGenericPanel = true;
      });
  }


  function setActiveEquipment(equipment) {
    vm.activeEquipmentId = equipment.id;

    sortEditable();
  }

  function updateValuesFromEvent(equipmentId, data) {
    const equipStatuses = vm.equipments[equipmentId].statuses;
    _.forEach(data, (point, key) => {
      if (key !== 'media' && _.has(equipStatuses, key)) {
        const currStatus = equipStatuses[key];
        if (_.isPlainObject(point)) {
          if (new Date(_.get(point, 'updatedAt')).getTime() > new Date(currStatus.updatedAt).getTime()) {
            currStatus.value = point.value;
            currStatus.updatedAt = point.updatedAt;
          }
        } else {
          currStatus.value = point;
          currStatus.updatedAt = false;
        }
      }
    });
  }

  function saveNewValues(dataPointKey) {
    const equipmentId = vm.activeEquipmentId;
    const valuesToSend = dataPointKey ?
      { [dataPointKey]: vm.equipments[equipmentId].tempValues[dataPointKey].value } :
      _.reduce(
        vm.equipments[equipmentId].tempValues,
        (memo, point, key) => _.assign(memo, { [key]: point.value }),
        {}
      );
    let growlMessage = growl.info('Saving Values', {
      disableCloseButton: true
    });

    return GenericPanelService.setSetPoints(equipmentId, {
      id: equipmentId,
      values: angular.copy(valuesToSend)
    })
      .then(({ data: failedSets }) => {
        growlMessage.destroy();
        growlMessage = growl.success('Action Successfully Issued.');

        _.forOwn(valuesToSend, (value, key) => {
          if (!_.includes(failedSets, key)) {
            _.merge(vm.equipments[equipmentId].statuses[key], { value, updatedAt: new Date().toISOString() });
            delete vm.equipments[equipmentId].tempValues[key];
          }
        });
        checkIsDirty();
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(err, {
          title: 'Error Saving: '
        });
      });
  }

  function editChange(dataPointKey) {
    const tempValue = vm.equipments[vm.activeEquipmentId].tempValues[dataPointKey]?.value;
    // if the user has deleted their input, cleanup the pending edit
    if (_.isNil(tempValue) || (_.isString(tempValue) && _.isEmpty(tempValue))) {
      cancelEdit(dataPointKey);
    }
    checkIsDirty();
  }

  function cancelEdit(dataPointKey) {
    if (dataPointKey) {
      delete vm.equipments[vm.activeEquipmentId].tempValues[dataPointKey];
    } else {
      vm.equipments[vm.activeEquipmentId].tempValues = {};
    }
    checkIsDirty();
  }

  function checkIsDirty() {
    vm.isDirty = !_.isEmpty(vm.equipments[vm.activeEquipmentId].tempValues);
  }

  function sortProperties() {
    vm.sortingEditable = false;

    const readings = vm.equipmentArrays[vm.activeEquipmentId];
    const sortBy = 2;
    const order = vm.sortPropertiesDirection === 0 || vm.sortPropertiesDirection === sortBy ? 'asc' : 'desc';
    vm.equipmentArrays[vm.activeEquipmentId] =
        _.orderBy(readings, ([id, obj]) => {
          if (obj.prettyName) {
            return obj.prettyName.toLowerCase();
          }
          return id.toLowerCase();
        }, order);

    vm.sortPropertiesDirection = order === 'asc' ? 1 : sortBy;
  }

  function sortEditable() {
    if (!vm.sortingEditable) {
      vm.sortPropertiesDirection = 0;
      vm.sortingEditable = true;

      const readings = vm.equipmentArrays[vm.activeEquipmentId];

      vm.equipmentArrays[vm.activeEquipmentId] =
          _.orderBy(readings, ([__, obj]) => !obj.configurable);

    }
  }

  function destroy() {
    GenericPanelService.destroy();
  }

  function isOfType(value) {
    return typeof value;
  }

  /**
   * @param {string} statusKey Ugly key of status
   * @param {string} id Equipment
   * @returns {string} Pretty-name, if any
   */
  function getPrettyName(statusKey, id) {
    return _.get(vm.equipments, [id, 'equipment', 'settings', 'pointPrettyNames', statusKey], statusKey);
  }
}
